<template>
  <div class="page-form">
    <div class="form__wrapper">
      <div class="form__item">
        <p>Your IP confirmation link has expired.</p>
      </div>
    </div>
    <div class="form__controls">
      <div class="form__submit">
        <button type="button" class="page-button" @click="refreshToken">
          <span></span><span>Send New IP Confirmation Link</span><span></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '@/lib/auth';

export default {
    name: 'RefreshIpTokenForm',
    props: {
        options: Object,
    },
    methods: {
        refreshToken() {
            Auth.refreshToken({
                token: this.options.token,
                type: 'ip',
                success: () => this.$emit('close'),
                error: () => {},
            });
        },
    },
}
</script>
